module.exports = __webpack_public_path__ + "static/media/other-software.214c9fd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Talent/assets/other-software.jpg
// module id = 555
// module chunks = 0